import React, { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import BuyerPortalLayout from '../../components/buyer/BuyerPortalLayout';
import { fetchBuyerQuotations } from '../../lib/buyerApi';

const BuyerQuotationsPage: React.FC = () => {
  const [quotations, setQuotations] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const res = await fetchBuyerQuotations();
      setQuotations(res.quotations || res.items || []);
    } catch (err) { console.error(err); }
    finally { setLoading(false); }
  }, []);

  useEffect(() => { load(); }, [load]);

  return (
    <BuyerPortalLayout title="Quotations">
      {loading ? (
        <div className="flex items-center justify-center py-16"><div className="w-10 h-10 border-4 border-emerald-500 border-t-transparent rounded-full animate-spin" /></div>
      ) : quotations.length === 0 ? (
        <div className="text-center py-16 bg-white rounded-2xl border border-gray-100">
          <p className="text-5xl mb-4">📋</p>
          <h3 className="text-lg font-bold text-gray-900 mb-2">No quotations yet</h3>
          <p className="text-gray-500 text-sm">Quotations will appear when suppliers respond to your RFQs.</p>
        </div>
      ) : (
        <div className="space-y-3">
          {quotations.map((q: any) => (
            <Link key={q.id} to={`/account/quotations/${q.id}`}
              className="block bg-white border border-gray-100 rounded-2xl p-5 hover:shadow-md transition">
              <div className="flex items-start justify-between">
                <div>
                  <div className="flex items-center gap-3">
                    <h3 className="font-bold text-gray-900">{q.quotation_number}</h3>
                    <span className={`px-2 py-0.5 rounded-full text-[10px] font-bold ${
                      q.status === 'accepted' ? 'bg-emerald-100 text-emerald-700' :
                      q.status === 'submitted' ? 'bg-blue-100 text-blue-700' :
                      q.status === 'rejected' ? 'bg-red-100 text-red-700' :
                      'bg-gray-100 text-gray-600'
                    }`}>{q.status}</span>
                  </div>
                  <p className="text-xs text-gray-500 mt-1">From: {q.supplier_name || 'Supplier'}</p>
                  {q.rfq_title && <p className="text-xs text-gray-400">RFQ: {q.rfq_title}</p>}
                </div>
                <p className="text-lg font-extrabold text-gray-900">{q.currency} {Number(q.total_amount || 0).toLocaleString()}</p>
              </div>
            </Link>
          ))}
        </div>
      )}
    </BuyerPortalLayout>
  );
};

export default BuyerQuotationsPage;
